<app-impersonation-banner *ngIf="gmService.user && isImpersonating"></app-impersonation-banner>

<mat-toolbar class="toolbar" xmlns="http://www.w3.org/1999/html">

  <!--  *************************** -->
  <!--            BEFORE            -->
  <!--  *************************** -->

  <div
    class="topbarBefore">
    <!--  *************************** -->
    <!--        HAMBURGER BUTTON      -->
    <!--  *************************** -->
    <dx-button
      style="z-index: 1"
      (onClick)="toggleDrawer.emit()"
      [disabled]="disabled"
      [stylingMode]="'text'">
      <i class="vr-ic_fluent_navigation_24_regular"></i>
    </dx-button>


    <!-- ******************************* -->
    <!--              LOGO               -->
    <!-- ******************************* -->
    <ng-container *ngIf="!appService.isSmallScreen()">
      <div style="
        display: flex;
        align-items: center;
        height: 100%;
        width: auto;">
        <img *ngIf="!appService.isDarkTheme"
             alt="innteaLogo"
             class="unselectable"
             height="240"
             ngSrc="../../../assets/keton-logo-top-bar.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
        <img *ngIf="appService.isDarkTheme"
             alt="innteaLogo"
             class="unselectable"
             height="240"
             ngSrc="../../../assets/keton-logo-top-bar-2.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
      </div>
      <span *ngIf="!!appService.menuVoice" class="unselectable component-title">
      {{ appService.printMenuVoiceName() | translate }}
    </span>
    </ng-container>
  </div>

  <div
    *ngIf="appService.isSmallScreen() && !topbarSelectorsComponent.isShown()"
    style="
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: auto;">
    <img *ngIf="!appService.isDarkTheme"
         alt="innteaLogo"
         class="unselectable"
         height="240"
         ngSrc="../../../assets/keton-logo-top-bar.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
    <img *ngIf="appService.isDarkTheme"
         alt="innteaLogo"
         class="unselectable"
         height="240"
         ngSrc="../../../assets/keton-logo-top-bar-2.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
  </div>


  <!--  *************************** -->
  <!--            CENTER            -->
  <!--  *************************** -->


  <app-topbar-selectors
    #topbarSelectorsComponent
    [disabled]="disabled"
    class="topbarCenter">
  </app-topbar-selectors>

  <!--  <span *ngIf="appService.isSmallScreen()" class="flexFill"></span>-->


  <!--  *************************** -->
  <!--             AFTER            -->
  <!--  *************************** -->


  <app-topbar-buttons
    (goToRequest)="goToRequest.emit($event)"
    *ngIf="!appService.isSmallScreen()"
    [disabled]="disabled"
    class="topbarAfter">
  </app-topbar-buttons>


  <!--  *************************  -->
  <!--        DROPDOWN MENU        -->
  <!--  *************************  -->

  <dx-menu
    #menu
    [height]="32"
    [hideSubmenuOnMouseLeave]="false"
    [width]="34"
    (onSubmenuHidden)="onSubMenuHidden($event)"
    (onSubmenuShown)="onSubMenuShown($event)">
    <dxi-item [closeMenuOnClick]="true" [cssClass]="'topbarMenu'" [height]="32" [width]="34">
      <div *dxTemplate style="padding: 5px; width: 34px; height: 32px;">
        <i class="vr-ic_fluent_more_vertical_48_regular"></i>
      </div>

      <dxi-item [visible]="appService.isSmallScreen()">
        <div *dxTemplate class="no-hover">
          <app-topbar-buttons
            (goToRequest)="goToRequest.emit($event);"
            [disabled]="disabled"
            class="topbarAfter"
            style="width: 100%">
          </app-topbar-buttons>
        </div>
      </dxi-item>

      <dxi-item [disabled]="true">
        <div *dxTemplate class="flexColumn userInfo" style="gap: 9px">
          <i class="vr-ic_fluent_person_24_regular userCircle"></i>
          <div class="flexRow" style="gap: 0.5ch">
            <span style="color: var(--dx-color-text)">{{ gmService.user.firstname }}</span>
            <span style="color: var(--dx-color-text)">{{ gmService.user.lastname }}</span>
          </div>
        </div>
      </dxi-item>
      <dxi-item [disabled]="true">
        <div *dxTemplate>
          <p *ngIf="env !== 'prod'" class="noMargin menuItemElement"
             style="color: var(--dx-color-text)">{{ printEnvironments() }}</p>
        </div>
      </dxi-item>
      <dxi-item [onClick]="openChangePassword">
        <div *dxTemplate>
          <i class="vr-ic_fluent_password_24_regular"></i>
          <span style="margin-left: 16px">{{ 'CHANGE_PASSWORD.COMPNAME' | translate }}</span>
        </div>
      </dxi-item>
      <dxi-item>
        <a *dxTemplate href="/manual"
           (click)="$event.preventDefault(); window.open(userManualURL, 'Manual', 'width=800,height=600,location=0,left=' + (window.screen.width/2-400) + ',top=' + (window.screen.height/2-300))"
           style="color: var(--dx-color-text); text-decoration: none">
          <i class="vr-ic_fluent_book_open_24_regular"></i>
          <span style="margin-left: 16px">{{ 'COMMON.MANUAL' | translate }}</span>
        </a>
      </dxi-item>
      <dxi-item>
        <div *dxTemplate>
          <div aria-label="Dark mode">
            <div style="display: flex; flex-direction: row; justify-content: space-between">
              <i class="vr-ic_fluent_dark_theme_24_regular"></i>
              <dx-switch
                (onValueChanged)="changeTheme($event)"
                [style.margin-left.px]="16"
                [switchedOffText]="'Dark Mode'"
                [switchedOnText]="'Light Mode'"
                [value]="appService.isDarkTheme">
              </dx-switch>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item>
        <i class="vr-ic_fluent_local_language_24_regular"></i>
        <span style="margin-left: 16px">{{ 'COMMON.LANGUAGE' | translate }}</span>
        <dxi-item *ngFor="let locale of languages">
          <div (click)="changeLanguage(locale.locale)" *dxTemplate
               [ngClass]="{'selectedLanguage': locale.locale === be.getLanguage()}"
               class="flag-icon-style">
            <span class="fi fi-{{locale.countryFlag}}"></span>
            <span class="flagText">{{ printLocaleText(locale.locale) }}</span>
          </div>
        </dxi-item>
      </dxi-item>
      <dxi-item [onClick]="logout">
        <div *dxTemplate>
          <i class="vr-ic_fluent_sign_out_24_regular"></i>
          <span style="margin-left: 16px">{{ 'COMMON.LOGOUT' | translate }}</span>
        </div>
      </dxi-item>
      <dxi-item [onClick]="linkToIubenda">
        <div *dxTemplate>
            <span class="envText unselectable" style="color: var(--dx-color-text)">
              <a class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iubendaLinkFromApp"
                 target="_blank"
                 title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w, d) {
              var loader = function () {
                var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0];
                s.src = "https://cdn.iubenda.com/iubenda.js";
                tag.parentNode.insertBefore(s, tag);
              };
              if (w.addEventListener) {
                w.addEventListener("load", loader, false);
              } else if (w.attachEvent) {
                w.attachEvent("onload", loader);
              } else {
                w.onload = loader;
              }
            })(window, document);</script>
            </span>
        </div>
      </dxi-item>
      <dxi-item [disabled]="true">
        <div *dxTemplate style="padding-top: 0; padding-bottom: 0;">
            <span class="envText unselectable"
                  style="color: var(--dx-color-text)">Ver. {{ gmService.getAppVersion() }}</span>
        </div>
      </dxi-item>
    </dxi-item>
  </dx-menu>

  <app-change-password #changePassword (closeDialog)="doChangePasswordRequest($event)"
                       *ngIf="changePasswordPopupOpen">
  </app-change-password>
</mat-toolbar>
